import http from './index'

const getAllBanks = async () => {
    return await http.get('/get/banks')
}

const getBankDetails = async (account_number, bank_code) => {
    return await http.get(`/get/bank-details/${account_number}/${bank_code}`)
}

const transferMoney = async (data) => {
    return await http.post('/transfer-fund', data)
}

export { getAllBanks, getBankDetails ,transferMoney}
